module.exports = __webpack_public_path__ + "static/media/appliances3.f032e92b.jpg";